import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'

import 'react-phone-input-2/lib/plain.css'
import './index_2.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style_2.css';
import './assets/css/line-awesome.min.css';
import './assets/css/fontawesome.min.css';

//import App from './App';
import Router from './container/router';
import { initializeFirebase } from './firebase/push-notification';
import * as serviceWorker from './serviceWorker';

import { checkBrowserAppleSafari } from './utils/commonUtilities';

import configureStore from './store/configureStore';
const store = configureStore();

const isSafariBrowser = checkBrowserAppleSafari();

ReactDOM.render(
    <Provider store={store}>
        <Router />
    </Provider>
    ,
    document.getElementById('root')
);

// if(!isSafariBrowser) initializeFirebase(); // APPLE SAFARI BROWSER DOES NOT SUPPORT FIREBASE PUSH NOTIFICATIONS 
initializeFirebase(); // APPLE SAFARI BROWSER DOES NOT SUPPORT FIREBASE PUSH NOTIFICATIONS 

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
